export enum HttpOperation {
  Post,
  Get,
  Put,
  Delete,
  None,
}
